<template>
    <v-dialog
    v-model="localDialog"
    width="50%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
    >
        <v-card>
            <v-card-title class="text-h6">
                <span>{{ isEntryMode ? "Add Cheque Book" : "Update Cheque Book" }}</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form @submit.prevent="submit" ref="ChequeBookSetup">
                    <v-row>
                        <v-col lg="6" md="6" cols="12">

                            <v-text-field
                            label="Start Cheque No"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            type="number"
                            v-model.number="start_cheque_no.value.value"
                            :error-messages="start_cheque_no.errorMessage.value"
                            clearable
                            >
                                <template #label>
                                    Start Cheque No <span class="text-red-accent-4">*</span>
                                </template>
                            </v-text-field>

                            <v-date-input
                            input-format="dd/mm/yyyy"
                            density="compact"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="received_date.value.value"
                            :error-messages="received_date.errorMessage.value"
                            autocomplete="off"
                            clearable
                            >
                                <template #label>
                                    Receive Date <span class="text-red-accent-4">*</span>
                                </template>
                            </v-date-input>
                        </v-col>

                        <v-col lg="6" md="6" cols="12">
                            <v-text-field
                            label="End Cheque No"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            type="number"
                            v-model.number="end_cheque_no.value.value"
                            :error-messages="end_cheque_no.errorMessage.value"
                            clearable
                            auto-grow
                            >
                                <template #label>
                                    End Cheque No <span class="text-red-accent-4">*</span>
                                </template>
                            </v-text-field>

                            <v-autocomplete
                            label="Bank Account"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="bank_account_id.value.value"
                            clearable
                            :items="getBankAccountList"
                            :error-messages="bank_account_id.errorMessage.value"
                            :item-title="item => `${item.account_no}`"   
                            autocomplete="off"
                            item-value="id"
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                <template #label>
                                    Bank Account <span class="text-red-accent-4">*</span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                    </v-row>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                            class="bg-red"
                            variant="flat"
                            type="reset"
                            @click="closeDialog"
                            >
                                Close
                            </v-btn>

                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { fileServerUrl } from "@/store/api";

export default {
    name: "ChequeBookSetup",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },

        data: {
            type: Object,
            default: () => ({
                start_cheque_no: "",
                end_cheque_no: "",
                bank_account_id: null,
                received_date: null,
            }),
        },
    },

    data() {
        return {
            localDialog: this.dialog,
            errorMessages: "",
            loading: false,
            isEntryMode: true,
        };
    },

    computed: {
        getBankAccountList() {
            return this.$store.getters.getBankAccountList;
        },
    },

    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {
            handler(newData) {
                this.isEntryMode = !newData.id;
                this.resetForm({ errors: {}, touched: {} });
                this.checkBook_id.setValue(newData.id || null, false);
                this.start_cheque_no.setValue(newData.start_cheque_no || null, false);
                this.end_cheque_no.setValue(newData.end_cheque_no || null, false);
                this.bank_account_id.setValue(newData.bank_account_id || null, false);
                this.received_date.setValue(newData.received_date || null, false);
            },
        },
    },

    created() { 
        // if (this.$store.getters.getBankAccountList.length === 0) {
            this.$store.dispatch("getBankAccountList", { type: "bank" });
        // }
    },
    
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
    },

    setup(props, { emit }) {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                start_cheque_no: yup.number().required().label("Start Cheque No"),
                end_cheque_no: yup.number().required().label("End Cheque No"),
                bank_account_id: yup.number().required().label("Bank Account Head"),
                received_date: yup.date().required().label("Received Date"),
            }),
        });

        const checkBook_id = useField("checkBook_id");
        const bank_account_id = useField("bank_account_id");
        const start_cheque_no = useField("start_cheque_no");
        const end_cheque_no = useField("end_cheque_no");
        const received_date = useField("received_date");
        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();

        const submit = handleSubmit((values) => {
            let action;
            if(values.checkBook_id){
                action = "updateChequeBook";
            } else {
                action = "saveChequeBook";
            }

            if(values.start_cheque_no > values.end_cheque_no){
                toast.error("Start Cheque No cannot be greater than End Cheque No");
                return;
            }

            store
            .dispatch(action, values)
            .then((response) => {
                resetForm();
                emit("update:dialog", false);
                toast.success(response.data.message);
                loading.value = true;
                store
                .dispatch("getChequeBookList")
                .then((data) => {
                    loading.value = false;
                })
                .catch((error) => {
                    loading.value = false;
                    toast.error(error.response.data.message);
                });
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
        });

        return {
            submit,
            checkBook_id,
            bank_account_id,
            start_cheque_no,
            end_cheque_no,
            received_date,
            errorMessages,
            resetForm,
            loading,
        };
    },
    mounted() {},
};
</script>
